import { CiIndicationChip } from 'app/main/integrations/cochlear/cochlear.components';
import { PageBreadcrumbDivider } from 'framework/components/breadcrumbs/PageBreadcrumbDivider';
import { PageBreadcrumbTitle } from 'framework/components/breadcrumbs/PageBreadcrumbTitle';
import { PageReloadButtonX } from 'framework/components/layout/PageReloadButtonX';
import { PageSettingsButtonX } from 'framework/components/layout/PageSettingsButtonX';
import { PageXHeaderActions } from 'framework/components/layout/PageXHeaderActions';
import { HorizontalTabsX } from 'framework/components/tabs/HorizontalTabsX';
import { IPatientDetail } from 'gen/ApiClient';
import RowStack from 'libs/ui/layout/stack/row.stack';
import React, { useContext, useMemo } from 'react';
import { RecordContext } from 'shared/records/RecordContext';
import { PatientSettingsAndViewPreferencesRoute } from '../PatientRoutes';
import { PatientStatusChip } from '../PatientStatusChip';
import { PatientsBreadcrumb } from '../PatientsBreadcrumb';
import { PatientDetailTabType, PatientDetailTabTypes } from './PatientDetailTabType';
import { PatientDetailTabTypeIconRecord } from './PatientDetailTabTypeIconRecord';
import { createPatientDetailTabTypeEndIconRecord } from './createPatientDetailTabTypeEndIconRecord';

function filterTabs(item: IPatientDetail) {
	let tabs = [...PatientDetailTabTypes];
	if (item.hasWiniproData === false) tabs = tabs.filter(t => t !== 'winipro');
	if (item.hasAcousoftData === false) tabs = tabs.filter(t => t !== 'acousoft');
	if (item.hasEazyworksData === false) tabs = tabs.filter(t => t !== 'eazyworks');
	return tabs;
}

type PatientDetailPageHeaderProps = {
	item: IPatientDetail;
	reload: VoidFunction;
	tab: PatientDetailTabType;
	setTab: React.Dispatch<React.SetStateAction<PatientDetailTabType>>;
};

export const PatientDetailPageHeader = ({ item, reload, tab, setTab }: PatientDetailPageHeaderProps) => {
	const { patientDetailTabTitleRecord } = useContext(RecordContext);
	const endIconRecord = useMemo(() => createPatientDetailTabTypeEndIconRecord(item), [item]);
	const tabs = useMemo(() => filterTabs(item), [item]);

	return (
		<div className='df-col fg1'>
			<div className='df-row-ac'>
				<PatientsBreadcrumb />
				<PageBreadcrumbDivider />
				<PageBreadcrumbTitle title={item.patient.lastNameCommaFirstNameBracketsNickName} />
				<RowStack
					dfrowac
					gap={0.5}>
					<PatientStatusChip
						item={item.patient}
						style={{ marginLeft: 4 }}
					/>
					{item.showCiCandidateLabel === true && (
						<CiIndicationChip
							push
							patientId={item.patient.id}
						/>
					)}
				</RowStack>
				<div className='fg1'></div>
				<PageXHeaderActions>
					<PageSettingsButtonX route={PatientSettingsAndViewPreferencesRoute} />
					<PageReloadButtonX
						reload={reload}
						reloadEveryXSeconds={process.env.NODE_ENV !== `development` && tab === 'noahData' ? 10 : undefined}
					/>
				</PageXHeaderActions>
			</div>
			<HorizontalTabsX
				tabs={tabs}
				selectedTab={tab}
				setSelectedTab={setTab}
				startIconRecord={PatientDetailTabTypeIconRecord}
				titleRecord={patientDetailTabTitleRecord}
				endIconRecord={endIconRecord}
				style={{
					marginTop: 16,
					marginLeft: -4,
				}}
			/>
		</div>
	);
};
